var map = {
	"./approval/store/index.ts": "f7ea",
	"./aproval/store/index.ts": "6400",
	"./chancepoint/store/index.ts": "ffc1",
	"./decision/store/index.ts": "cd42",
	"./demo/store/index.ts": "28f2",
	"./developer/store/index.ts": "e405",
	"./dynamicform/store/index.ts": "cd2b",
	"./employee/store/index.ts": "98cc",
	"./fishtogether/store/index.ts": "a8e4",
	"./home/store/index.ts": "b31f",
	"./iframe/store/index.ts": "3b80",
	"./longerpoppupshop/store/index.ts": "cf8c",
	"./map/store/index.ts": "4031",
	"./message/store/index.ts": "b3bd",
	"./place/store/index.ts": "6a99",
	"./preload/store/index.ts": "cdfb",
	"./protocol/store/index.ts": "dbd6",
	"./shoprecommend/store/index.ts": "6627",
	"./shops/store/index.ts": "e657",
	"./spotsurvey/store/index.ts": "0a66",
	"./standardstore/store/index.ts": "5c17",
	"./task/store/index.ts": "9c0b",
	"./test/store/index.ts": "6b98",
	"./workbench/store/index.ts": "d2e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf0e";